import { Module } from '../models/module';

const normalizeRoute = (route?: string | null) => {
  const trimmed = String(route || '').trim();
  if (!trimmed) {
    return '';
  }

  return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
};

export const buildAuthorizedModulesFromAuthUser = (authUserData: any): Module[] => {
  const permissions = Array.isArray(authUserData?.role?.permissions)
    ? authUserData.role.permissions
    : [];

  const visiblePermissions = permissions.filter(
    (permission: any) => permission?.action === 'toggle_visibility' && permission?.menu?.id
  );

  const modulesMap = new Map<number, any>();

  for (const permission of visiblePermissions) {
    const menu = permission.menu;
    const module = menu?.module;
    const moduleId = Number(module?.id || 0);
    const menuId = Number(menu?.id || 0);

    if (!moduleId || !menuId) {
      continue;
    }

    if (!modulesMap.has(moduleId)) {
      modulesMap.set(moduleId, {
        id: moduleId,
        name: module?.name || '',
        order: Number(module?.order ?? 0),
        icon: module?.icon || '',
        menu: [],
      });
    }

    const currentModule = modulesMap.get(moduleId);
    if (!currentModule.menu.some((item: any) => Number(item.id) === menuId)) {
      currentModule.menu.push({
        id: menuId,
        name: menu?.name || '',
        route: normalizeRoute(menu?.route),
        order: Number(menu?.orden ?? menu?.order ?? 0),
        orden: Number(menu?.orden ?? menu?.order ?? 0),
        icon: menu?.icon || '',
      });
    }
  }

  return Array.from(modulesMap.values())
    .map((module) => ({
      ...module,
      menu: [...module.menu].sort((left, right) => Number(left.order ?? 0) - Number(right.order ?? 0)),
    }))
    .sort((left, right) => Number(left.order ?? 0) - Number(right.order ?? 0)) as Module[];
};
